import { userResourcesLanguageItalian } from '../userResources';

import type { RolesTranslationMessages } from './rolesTranslationMessages';

export const rolesLanguageItalian: RolesTranslationMessages = {
  roles: {
    ...userResourcesLanguageItalian.groups,
    name: 'Ruoli',
    description:
      'Selezionando il ruolo, tutti i permessi saranno generati automaticamente. Potrai comunque modificarli successivamente.',
    fields: {
      ...userResourcesLanguageItalian.groups.fields,
      name: 'Nome ruolo',
    },
    operations: {
      ...userResourcesLanguageItalian.groups.operations,
      create: 'Crea ruolo',
      delete: 'Elimina il ruolo',
      edit: 'Modifica ruolo',
      sections: {
        ...userResourcesLanguageItalian.groups.operations.sections,
        groupsInfo: 'Info ruolo',
      },
    },
    helperTexts: {
      acl_labels: 'Elenco di etichette ACL per questo ruolo',
    },
    names: {
      admin: {
        name: 'Admin',
        description: 'Tutti i permessi su tutte le risorse',
      },
      userManager: {
        name: 'Gestore Utenti',
        description: 'Gestisce gli utenti e tutte le risorse correlate',
      },
      queueManager: {
        name: 'Gestore Code',
        description: 'Gestisce le code e tutte le risorse correlate',
      },
      flowManager: {
        name: 'Gestore Flussi',
        description: 'Gestisce i dialplan e tutte le risorse correlate',
      },
      supervisor: {
        name: 'Supervisore',
        description: 'Può vedere CDR e registrazioni',
      },
      opSupervisor: {
        name: 'Supervisore PO',
        description: 'Visibilità e gestione completa del Pannello Operatore',
      },
    },
  },
};
